/**
 * CÓDIGO TÉCNICO TRADUZIDO (§20.3).
 *
 * Vive no CONTRATO, e não em um dos dois lados, porque os dois precisam dele: o
 * servidor para responder, a tela para exibir quando a resposta vier só com o
 * código. Duas cópias divergiriam — e a divergência apareceria como duas frases
 * diferentes para o mesmo problema, o que faz a pessoa achar que são problemas
 * diferentes.
 *
 * A frase diz o que FAZER. Um código traduzido para outro substantivo
 * ("Política negada") continua sem ajudar quem está parado na tela.
 */

export const TRADUCAO_DE_CODIGO: Record<string, string> = {
  VALIDATION_ERROR: 'Faltou preencher alguma coisa, ou um valor não é aceito. Confira os campos.',
  UNAUTHENTICATED: 'Sua sessão expirou. Entre de novo para continuar.',
  FORBIDDEN: 'Você não tem permissão para esta ação. Peça a quem administra o sistema.',
  NOT_FOUND: 'Não encontrei este registro — ou ele está fora da sua carteira.',
  CONFLICT: 'O estado atual não permite esta ação. A tela explica o que está no caminho.',
  PRECONDITION_FAILED: 'Falta alguma coisa antes desta ação. A mensagem diz o quê.',
  CONCURRENT_MODIFICATION:
    'Outra pessoa alterou este registro enquanto você olhava. Recarregue e refaça.',
  RATE_LIMITED: 'Muitas tentativas em pouco tempo. Espere um instante e tente de novo.',
  AGENT_PAUSED: 'Este agente está pausado pela administração. A tela de agentes diz por quê.',
  POLICY_DENIED:
    'Esta ação passa da sua alçada. Peça aprovação a quem responde pelo resultado — o pedido já ' +
    'fica registrado.',
  NEEDS_APPROVAL: 'Esta ação precisa da aprovação de outra pessoa antes de acontecer.',
  AI_UNAVAILABLE:
    'O assistente está indisponível agora. O resto do sistema continua funcionando normalmente.',
  /**
   * CERES-EST-002 §6.6 — código PRÓPRIO, e não `CONFLICT`.
   *
   * A ação de quem recebe é outra: em `CONFLICT` a pessoa corrige o dado; aqui
   * ela precisa de mais assentos, e quem decide isso é outra pessoa, por outro
   * caminho. Misturar os dois manda metade dos pedidos para o lugar errado.
   */
  SEAT_LIMIT_REACHED:
    'O limite de usuários do plano foi alcançado. Peça a quem administra o plano para ampliar os ' +
    'assentos antes de ativar mais alguém.',
  ROUTE_DEPRECATED:
    'Este caminho foi descontinuado. A mensagem indica a tela ou a rota que o substitui.',
  INTERNAL_ERROR: 'Algo deu errado do nosso lado. A equipe consegue investigar pelo código da tela.',
};

export function traduzirCodigo(codigo: string): string {
  return (
    TRADUCAO_DE_CODIGO[codigo] ??
    // Mesma disciplina do rótulo: nada de mostrar o código cru como se fosse
    // uma frase. Um código que ninguém traduziu é um defeito, não um texto.
    'Não foi possível concluir. Se continuar, acione o suporte com o código da tela.'
  );
}

